import { useMutation, useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { RENDER_QUEUES, TEAMS, UPDATE_RENDER_QUEUE } from '../../api/GraphQL';
import Column from '../ui/Column';
import Button from '../ui/form/Button';
import Input from '../ui/form/Input';
import Panel from '../ui/Panel';
import Row from '../ui/Row';

const Main = styled.div``;

export default function RenderQueue() {
  const { queueid } = useParams();
  const { data: queues } = useQuery(RENDER_QUEUES);
  const { data: teams } = useQuery(TEAMS);
  const [updateRenderQueue, {}] = useMutation(UPDATE_RENDER_QUEUE, {
    refetchQueries: ['RenderQueues'],
  });
  const [name, setName] = useState('');
  const [members, setMembers] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState();
  const [data, setData] = useState();

  useEffect(() => {
    if (queues) {
      setData(queues.renderQueues.find((q) => q._id === queueid));
    }
  }, [queues, queueid]);

  useEffect(() => {
    setName(data?.name);
    setMembers(data?.teams);
  }, [data]);

  return (
    <Main>
      <Panel title={'Update Render Queue'} border_title={true}>
        <Column size="12">
          <Row>
            <Column size="4">
              <Input
                id="new_name"
                label={'Name'}
                placeholder={'Render Queue Name'}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Column>
          </Row>
          <Row>
            <Column size="4">
              <select
                onChange={(e) => {
                  setSelectedTeam(
                    teams?.teams?.find((u) => u?._id === e.currentTarget.value)
                  );
                }}
              >
                <option selected={!selectedTeam}>Select team</option>
                {teams?.teams
                  ?.filter(
                    (u) => members?.findIndex((m) => m?._id === u._id) === -1
                  )
                  .map((team) => {
                    return (
                      <option
                        value={team?._id}
                        selected={selectedTeam?._id === team?._id}
                      >
                        {team.name}
                      </option>
                    );
                  })}
              </select>
              {selectedTeam && (
                <Button
                  label="Add to team"
                  onClick={() => {
                    setMembers([...members, selectedTeam]);
                    setSelectedTeam();
                  }}
                />
              )}
            </Column>
          </Row>
          <Row>
            {members?.map((member) => {
              return (
                <Row>
                  <Button
                    label="Remove"
                    onClick={() => {
                      let new_members = [...members];
                      new_members = new_members?.filter(
                        (m) => m?._id !== member?._id
                      );
                      setMembers(new_members);
                      setSelectedTeam();
                    }}
                  />
                  {member?.name}{' '}
                </Row>
              );
            })}
          </Row>
          <Row>
            <Column size={12}>
              <Button
                primary
                label={'Save'}
                onClick={() => {
                  updateRenderQueue({
                    variables: {
                      _id: data?._id,
                      name: name,
                      teams: members?.map((m) => m?._id?.toString()),
                    },
                  });
                }}
              />
            </Column>
          </Row>
        </Column>
      </Panel>
    </Main>
  );
}
